module.exports = __webpack_public_path__ + "img/T1.67d59556.png";